function getActivePage(namedTag) {
  if (namedTag.pages === null || namedTag.pages === void 0) {
    return void 0;
  }
  return namedTag.pages.find(p => p.active);
}
export { getActivePage };
